(ns manatee.components.editors.app-db)

(def editors-root [:editors])
(def spelling-dictionary-path (conj editors-root :spelling-dictionary))
(def misspelled-words-path (conj editors-root :misspelled-words))

(defn spelling-dictionary
  [db]
  (get-in db spelling-dictionary-path))

(defn update-spelling-dictionary
  [db words]
  (update-in db spelling-dictionary-path merge words))

(defn misspelled-words
  [db]
  (get-in db misspelled-words-path))

(defn set-misspelled-words
  [db words]
  (assoc-in db misspelled-words-path words))
